import { Icon, IconProps } from '../Icon'

export const EditIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      edit
    </Icon>
  )
}
